import React from 'react';
import './Box.css';
import { Link } from 'react-router-dom';
function Box() {
  return (
    <div>
    <div className="gap-div">
    </div>
      <div className="box-container">
      <Link to="/table/Wheat" className="box">
          WHEAT
        </Link>
        <Link to="/table/Maize" className="box">
          MAIZE
        </Link>
        <Link to="/table/Paddy_(not_shelled_rice)" className="box">
        PADDY
        </Link>
        <Link to="/table/Cotton" className="box">
          COTTON
        </Link><Link to="/table/Bajra" className="box">
          BAJRA
        </Link>
        <Link to="/table/Soyabean" className="box">
          SOYABEAN
        </Link><Link to="/table/Moong" className="box">
          MOONG
        </Link>
        <Link to="/table/Sunflower" className="box">
          SUNFLOWER
        </Link>
      </div>
      
    </div>
  );
}

export default Box;
